import Client from "@/app/repository/axios-client";

const resource = '/message/messages';

export default {
  createDraft(payload) {
    return Client.post(`${resource}`, payload);
  },
  changeDraft(messageId, payload) {
    return Client.put(`${resource}/${messageId}`, payload);
  },
  removeDraft(messageId, version) {
    return Client.delete(`${resource}/${messageId}?version=${version}`);
  },
  getMessage(messageId) {
    return Client.get(`${resource}/${messageId}`);
  },
  getMessagesForGrid(parameters) {
    return Client.get(`${resource}` + parameters);
  },
  sendMessage(messageId, payload) {
    return Client.put(`${resource}/${messageId}/send`, payload);
  },
  countUnread() {
    return Client.get(`${resource}/count-unread`);
  },
  addRecipientToDraft(messageId, payload) {
    return Client.post(`${resource}/${messageId}/recipients`, payload);
  },
  removeAddedRecipients(messageId, payload) {
    return Client.delete(`${resource}/${messageId}/recipients`, { data: payload });
  },
  findAllRecipientsByMessageId(messageId) {
    return Client.get(`${resource}/${messageId}/recipients`);
  },
  sendMessageReply(messageId, payload) {
    return Client.post(`${resource}/${messageId}/send-reply`, payload);
  },
  markAsRead(messageId) {
    return Client.put(`${resource}/${messageId}/mark-as-read`);
  },
  markAsUnread(messageId) {
    return Client.put(`${resource}/${messageId}/mark-as-unread`);
  },
};
